<template>
	<view class="dropdown-container">
		<!-- 显示选中的项 -->
		<view class="selected-item">
			<view class="icon-view"  @click="toggleDropdown" :class="isOpen?'active':''">
				<view class="item-icon" :style="{ backgroundPosition: currItem.countryFlag }"></view>
				<!-- <uni-icons type="down" size="15" color="#999" class="down-btn"></uni-icons> -->
				<Icon 
					:icon="isOpen ? 'mdi:chevron-up' : 'mdi:chevron-down'" 
					:width="20" 
					:height="20"
					color="#666"
					/>
			</view>
			<view class="input-item-container">
				<view class="area-code"  v-if="currItem.countryFlag"> {{currItem.countryCode}}</view>
<!-- 				<input class="item-input" :modelValue="modelValue" @input="$emit('input', $event.target.value)"/> -->
				<input class="item-input" :modelValue="modelValue" @input="handleInput" placeholder="Please enter phone No."/>
			</view>
		</view>
		
		<!-- 下拉列表 -->
		<div class="dropdown-list"  v-if="isOpen">
			<div class="selected-view">
				<view class="item-icon"  :style="{ backgroundPosition: currItem.countryFlag }" />
				<text class="item-text">{{ currItem.countryName }}({{ currItem.countryCode }})</text>
			</div>
			<div class="dropdown-item" v-for="(item, index) in items" :key="index" @click = "selectItem(item)">
				<!-- <image class="item-icon" :src="item.icon"></image> -->
				<div class="item-icon"  :style="{ backgroundPosition: item.countryFlag }"></div>
				<text class="item-text">{{ item.countryName }}({{ item.countryCode }})</text>
			</div>
		</div>
	</view>
</template>

<script>
import { Icon } from '@iconify/vue';

	export default {
		components: {
			Icon
		},
		name: 'ImageSelect',
		props: {
			items: {
				type: Array,
				default: () => []
			},
			currItem:{
				type: Object,
				default: () => {
					return {
						countryFlag: "-1px -69px",
						countryName: "UnitedStates",
						countryCode: "+1",
						shortName: "us"
					}
				}
			}
		},
		data() {
			return {
				isOpen: false,
			}
		},
		created() {
		},
	
		methods: {
	
			toggleDropdown() {
				this.isOpen = !this.isOpen
			},
			selectItem(item) {
				this.isOpen = false
				this.$emit('telselect', item)
			},
			handleInput(e){
				this.$emit('update:modelValue', e.target.value);
				// this.$emit('update:modelValue', e.detail.value);
			}
		}
	}
</script>

<style scoped>
	.dropdown-container {
		width: 100%;
		box-sizing: border-box;
	}

	.selected-item {
		display: flex;
		align-items: center;
		cursor: pointer;
		width: 100%;
		box-sizing: border-box;
		height:30px;
	}
	
	.dropdown-list-view{
		width:100%;
		display: flex;
		height: 300px;
	}
	
	.selected-view{
		display: flex;
		align-items: center;
		justify-content: center;
		border-bottom: 1px solid #E6DFCF;
		padding:10px 10px 10px 0;
		width:100%;
	}
	
	.selected-view:hover {
		background-color: #E6DFCF;
	}

	.dropdown-list {
		position: absolute;
		width: 300px;
		background: white;
		z-index: 100;
		box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
		background-color: #fff;
		padding: 0px 10px 10px 0;
		height: 240px;
		overflow-y: auto;
	}

	@media (max-width: 895px){
		.dropdown-list {
			width:240px;
		}
	}

	.dropdown-item {
		display: flex;
		align-items: center;
		justify-content: center;
		margin-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);top:20px;
		margin-top:15px;
		
	}

	.dropdown-item:hover {
		background-color: #E6DFCF;
	}

	.down-btn{
		margin-left: auto;
		width:30px;
		
	}
	
	.item-icon {
		width: 24px;
		height: 16px;
		background: url('@/assets/images/flags.png') no-repeat 0 0; /* 雪碧图路径 */
		/* background-position: -1px -69px; */
		background-size: 24px 4012px;
		overflow: hidden;
	}

	.item-text {
		font-size: 12px;
		margin-left: 10px;
		width:90%;
	}

	.input-item-container{
		width:100%;
		display: flex;
		height: 30px;
		border:1px solid #E7E1D7;
		border-top-right-radius: 6px;
		border-bottom-right-radius:6px;
		
	}
	
	.icon-view{
		display: flex;
		height: 100%;
		width: 80px;
		justify-content: center;
		align-items: center;
		padding-left: 10px;
		padding-right: 10px;
		border:1px solid #E7E1D7;
		border-top-left-radius: 6px;
		border-bottom-left-radius: 6px;
		border-right: none;
		
	}
	
	.icon-view.active{
		background-color: #fff;
	}

	.item-input {
		width: 100%;
		font-size: 16px;
		border:none;
		flex:1;
		border-radius: 6px;
		
	}

	.item-input::placeholder{
		font-size:14px;
	}

	@media (max-width:895px) {
		.item-input {
			font-size:12px;
		}
		.item-input::placeholder{
			font-size:10px;
		}
	}
	
	.area-code{
		display: flex;
		background-color: #fff;
		font-size: 14px;
		min-width: 40px;
		padding-left: 5px;
		align-items: center;
			
	}
	
</style>